// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__15htw","icon":"styles_icon__b2Utf"};